import { render, staticRenderFns } from "./create-client.vue?vue&type=template&id=f79de40c&"
import script from "./create-client.vue?vue&type=script&lang=ts&"
export * from "./create-client.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports